import React from 'react';
import styled from 'styled-components';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Image from './image';

const Slideshow = ({
  slides = [],
  imageOptions = [],
  breakpoint = 576,
}) => (
  <SwiperWrapper breakpoint={breakpoint}>
    <Swiper
      modules={[Navigation, A11y]}
      navigation
      watchOverflow
      css="position: relative; margin-bottom: 1rem;"
      slidesPerView={1.3}
      spaceBetween={15}
      centeredSlides
      loop
      breakpoints={{
        [breakpoint]: {
          slidesPerView: 1,
          spaceBetween: 0,
          centeredSlides: false,
        },
      }}
    >
      {slides.map(({ image, alt, ...props }) => image && (
        <SwiperSlide key={image.id}>
          {({ isActive, isPrev, isNext }) => (
            <Image
              {...props}
              lazy
              isActiveInLazy={isActive || isPrev || isNext}
              image={image}
              options={imageOptions}
              width="100%"
              alt={alt}
            />
          )}
        </SwiperSlide>
      ))}
    </Swiper>
  </SwiperWrapper>
);

const SwiperWrapper = styled.div`
  margin-left: -${({ theme }) => theme.grid.containerGap};
  margin-right: -${({ theme }) => theme.grid.containerGap};

  @media all and (min-width: ${({ breakpoint }) => breakpoint}px) {
    margin-left: 0;
    margin-right: 0;
  }
  .swiper-button-prev {
    left: 0rem;
  }
  .swiper-button-next {
    right: 0rem;
  }
  [class^="swiper-button-"] {
    color: white;
    background-color: rgba(0, 0, 0, 0.6);
    padding: .5rem;
    visibility: hidden;
    @media all and (min-width: ${({ breakpoint }) => breakpoint}px) {
      visibility: visible;
    }
    &:after {
      font-size: 1rem;
      @media all and (min-width: ${({ theme }) => theme.breakingpoints.md}) {
        font-size: 1.5rem;
      }
    }
    &.swiper-button-disabled {
      display: none;
    }
  }
`;

export default Slideshow;
